import React from 'react'

const Gas = ({color = null}) => {
  return (
    <svg viewBox="0 0 65 65">
      <path
        fill={color ? color : '#3F5063'}
        d="M33,57c-11,0-20-9.1-20-20.2c0-9.9,4.8-14.9,5-15.1c0.3-0.3,0.7-0.4,1.1-0.2c0.4,0.2,0.6,0.5,0.6,0.9
	c0,0.3,0,7.4,5.3,10.8c-3.3-12.2,2.5-17,7.2-20.9c1.9-1.6,3.7-3.1,4.6-4.8c0.2-0.5,0.8-0.7,1.3-0.5s0.7,0.7,0.6,1.2
	c-2.2,6.5,0.9,14.3,2.9,18.5c0.4-2.9,1.6-6.9,4.9-9.9c0.3-0.3,0.8-0.3,1.2-0.1c0.4,0.2,0.6,0.7,0.5,1.1c-1.1,4.7,0.2,6.7,1.8,9.3
	c1.4,2.3,3,4.9,3,9.7C53,47.9,44,57,33,57z M18,25.1c-1.3,2.2-3,6.1-3,11.7c0,10,8.1,18.2,18,18.2c9.9,0,18-8.2,18-18.2
	c0-4.2-1.4-6.5-2.7-8.7c-1.2-2-2.5-4-2.4-7.4c-2.8,4.3-2.4,9.5-2.3,9.5c0,0.5-0.2,0.9-0.7,1c-0.4,0.1-0.9,0-1.2-0.4
	c-0.3-0.5-6.3-9.9-5.7-19.1c-0.8,0.7-1.6,1.4-2.5,2.1c-4.8,3.9-10.2,8.3-5.9,20.9c0.1,0.4,0,0.8-0.3,1c-0.3,0.3-0.7,0.4-1,0.2
	C20.4,33.9,18.6,28.4,18,25.1z"
      />
    </svg>
  )
}

export default Gas
